import Vue from 'vue'
import fetch from '../../../../utils/fetch'
import SubmissionError from "../../../../error/SubmissionError";

const getInitialState = () => {
  return {
    isLoading: false,
    activated: false,
    error: '',

    decodedToken: null,
    expiredToken: false,
    tokenExpiry: null,
    invalidToken: false,
    isLoadingEmail: false,
    emailSent: false,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  activated(state) {
    return state.activated
  },
  error(state) {
    return state.error
  },

  expiredToken(state) {
    return state.expiredToken
  },
  tokenExpiryDateTime(state) {
    if (!state.decodedToken || !state.decodedToken.exp) return ''
    return moment(state.decodedToken.exp * 1000).format('ddd MMMM DD, YYYY h:mm:ss a')
  },
  invalidToken(state) {
    return state.invalidToken
  },
  isLoadingEmail(state) {
    return state.isLoadingEmail
  },
  emailSent(state) {
    return state.emailSent
  },
  decodedToken(state) {
    return state.decodedToken
  },
}

const actions = {

  activate({commit, dispatch, state, rootGetters}, jwt) {
    // Skip activation if the token is expired or invalid
    if (state.expiredToken || state.invalidToken) {
      return
    }

    commit(types.ACTIVATE_ACCOUNT_LOADING)
    return fetch('/users/' + state.decodedToken.code + '/activate', {
      method: 'PATCH',
      body: JSON.stringify({'token': jwt})
    }).then(response => {
      return response.json()
    })
      .then((data) => {
        commit(types.ACTIVATE_ACCOUNT, true)
        dispatch('user/profile/fetchSession', null, {root: true})
      })
      .catch((e) => {
        commit(types.ACTIVATE_ACCOUNT_ERROR, e.message)
      })
  },

  checkToken({commit}, jwt) {
    if (jwt === 'undefined' || !jwt) {
      commit(types.ACTIVATE_SET_INVALID_TOKEN, true)
      return
    }

    let payload = null
    try {
      payload = Vue.$jwt.decode(jwt)
      if (!payload || payload.subject !== 'activate account') {
        commit(types.ACTIVATE_SET_INVALID_TOKEN, true)
        return
      }
    } catch (e) {
      commit(types.ACTIVATE_SET_INVALID_TOKEN, true)
      return
    }

    const currentTime = new Date().getTime() / 1000
    if (currentTime > payload.exp) {
      commit(types.ACTIVATE_SET_EXPIRED_TOKEN, true)
    }

    // Decoded token is set if JWT is valid
    commit(types.ACTIVATE_DECODED_TOKEN, payload)
  },

  reset({commit}) {
    commit(types.RESET)
  },

  resendEmail({commit}, data) {
    commit(types.ACTIVATE_RESEND_EMAIL_LOADING, true)
    const page = '/users/' + data.id + '/resend_activation'
    return fetch(page, {method: 'PATCH', body: JSON.stringify({'resendVerificationEmail': true})})
      .then(response => {
        return response.json()
      })
      .then(() => {
        commit(types.ACTIVATE_RESEND_EMAIL, true)
      })
      .catch((e) => {
        if (e instanceof SubmissionError) {
          commit(types.ACTIVATE_ACCOUNT_ERROR, e.errors._error)
        }

        // eslint-disable-next-line
        commit(types.ACTIVATE_ACCOUNT_ERROR, e.errors._error)
      })
  }
}

const types = {
  ACTIVATE_ACCOUNT_LOADING: 'ACTIVATE_ACCOUNT_LOADING',
  ACTIVATE_ACCOUNT: 'ACTIVATE_ACCOUNT',

  ACTIVATE_DECODED_TOKEN: 'ACTIVATE_DECODED_TOKEN',
  ACTIVATE_SET_EXPIRED_TOKEN: 'ACTIVATE_SET_EXPIRED_TOKEN',
  ACTIVATE_SET_INVALID_TOKEN: 'ACTIVATE_SET_INVALID_TOKEN',

  ACTIVATE_RESEND_EMAIL_LOADING: 'ACTIVATE_RESEND_EMAIL_LOADING',
  ACTIVATE_RESEND_EMAIL: 'ACTIVATE_RESEND_EMAIL',

  ACTIVATE_ACCOUNT_ERROR: 'ACTIVATE_ACCOUNT_ERROR',
  RESET_ERROR: 'RESET_ERROR',
  RESET: 'RESET',
}

const mutations = {
  [types.ACTIVATE_ACCOUNT_LOADING](state) {
    state.isLoading = true;
  },
  [types.ACTIVATE_ACCOUNT](state) {
    state.activated = true;
    state.isLoading = false;
  },
  [types.ACTIVATE_ACCOUNT_ERROR](state, error) {
    state.error = error;
    state.isLoading = false;
    state.isLoadingEmail = false;
  },
  [types.ACTIVATE_DECODED_TOKEN](state, payload) {
    state.decodedToken = payload;
  },
  [types.ACTIVATE_SET_EXPIRED_TOKEN](state, expiredToken) {
    state.expiredToken = expiredToken;
    state.isLoading = false;
  },
  [types.ACTIVATE_SET_INVALID_TOKEN](state, invalidToken) {
   state.invalidToken = invalidToken;
    state.isLoading = false;
  },
  [types.ACTIVATE_RESEND_EMAIL_LOADING](state) {
    state.isLoadingEmail = true;
  },
  [types.ACTIVATE_RESEND_EMAIL](state, emailSent) {
    state.emailSent = emailSent;
    state.isLoadingEmail = false;
  },

  [types.RESET_ERROR](state) {
    state.error = null;
  },
  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
}
